export const UPDATE_NEWS = 'SYNC_HASHES_UPDATE_NEWS_HASH'
export const UPDATE_CREATIVES = 'SYNC_HASHES_UPDATE_CREATIVES_TIMESTAMP'
export const UPDATE_MOTD = 'SYNC_HASHES_UPDATE_MOTD_TIMESTAMP'
export const UPDATE_HASH = 'SYNC_HASHES_UPDATE_HASH'



// WEBPACK FOOTER //
// ./src/features/Sync/data/hashes/constants.js